<template>
  <div class="view box grow" v-loading="rulesListReqStatus === 'loading'">
    <page-headers
      :header="'MITRE ATT&CK Matrix'"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      class="box"
    />
    <div class="flex box grow attack-matrix" v-if="rulesListReqStatus === 'saved'">
      <div
        class="flex column box grow"
        v-for="mitreTactic in tacticDisplayList"
        :key="mitreTactic.x_mitre_shortname"
      >
        <span class="tactic title">{{mitreTactic.name}}</span>
        <div
          class="technique flex box"
          v-for="mitreTechnique in mitreTactic.techniques"
          :key="mitreTechnique.id"
          :class="{'covered': mitreTechnique.confluera_coverage}"
        >
          <span class="value body2">
            <a
              :href="mitreTechnique.external_references[0].url"
              target="_blank"
              rel="noreferrer"
            >{{mitreTechnique.name}}</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageHeaders from "@/components/layout/PageHeaders.vue";
import {
  RULES_LIST_REQ,
  RULES_LIST_SUCCESS
} from "@/store/modules/rules/rules.type";
import {
  MITRE_TACTIC_LIST_REQ,
  MITRE_TECHNIQUE_LIST_REQ,
  MITRE_COVERAGE_SET
} from "@/store/modules/mitre-attack/mitre-attack.type";

export default {
  name: "MitreAttackCoverage",
  data() {
    return {
      breadcrumbs: [{ title: "Home" }, { title: "MITRE ATT&CK Coverage" }],
      tacticDisplayOrder: [
        "initial-access",
        "execution",
        "persistence",
        "privilege-escalation",
        "defense-evasion",
        "credential-access",
        "discovery",
        "lateral-movement",
        "collection",
        "command-and-control",
        "exfiltration",
        "impact"
      ]
    };
  },
  created() {
    if (!this.mitreCoverageMarked) {
      this.$store.dispatch(MITRE_TACTIC_LIST_REQ).then(() => {
        this.$store.dispatch(MITRE_TECHNIQUE_LIST_REQ).then(() => {
          this.$store.dispatch(RULES_LIST_REQ).then(rules => {
            this.mitreTacticList.forEach(tactic => {
              tactic.markIQCoverage(
                _.filter(this.rulesList.models, rule => {
                  return _.some(tactic.external_references, {
                    external_id: rule.tactic
                  });
                })
              );
            });
            this.$store.dispatch(MITRE_COVERAGE_SET, true);
            this.$store.dispatch(RULES_LIST_SUCCESS);
          });
        });
      });
    }
  },
  computed: {
    tacticDisplayList() {
      let orderedList = [];
      this.tacticDisplayOrder.forEach(displayTactic => {
        orderedList.push(
          _.find(this.mitreTacticList, { x_mitre_shortname: displayTactic })
        );
      });
      return orderedList;
    },
    ...mapGetters([
      "rulesListReqStatus",
      "rulesList",
      "mitreTacticListReqStatus",
      "mitreTacticList",
      "mitreCoverageMarked"
    ])
  },
  components: {
    PageHeaders
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
@import "assets/styles/text.css";
@import "assets/styles/icon.css";

.attack-matrix {
  overflow: auto;
  height: calc(100%-100px);
  text-align: center;
  background: var(--aluminum-200) !important;
  border-left: 1px solid var(--border-color);
  border-right: 1px solid var(--border-color);
}

.flex.column {
  min-width: 120px;
}

.flex.box:not(.column) {
  padding: 5px;
  background: white;
  word-break: break-word;
  text-align: center;
  border-bottom: 1px solid var(--border-color);
  border-left: 1px solid var(--border-color);
  border-right: 1px solid var(--border-color);
}

.title {
  background: var(--aluminum-600);
  color: white;
}

.value {
  width: 100%;
}

.technique {
  &.covered {
    background: var(--denim-50) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mitreattack/MitreAttackCoverage.vue